import { Link } from 'react-router'

export function NotFoundPage() {
  return (
    <section className="py-10 text-center">
      <h2 className="text-title font-semibold text-ink">Nothing here</h2>
      <p className="mt-2 text-ui text-muted">
        That page does not exist.{' '}
        <Link to="/queue" className="text-accent underline underline-offset-2">
          Back to the queue
        </Link>
        .
      </p>
    </section>
  )
}
